<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
    mustlogin(){
        const  token_type =store.state.token_type
        const  access_token = store.state.token
        console.log(token_type)
        if((token_type!=null || access_token!=null)){
            router.push({path:'/login'})
        }
    }
  }
}

</script>

<style>
  body{
    margin: 0px;
    padding:0px;
  }

 html,body,#app {height: 100%;}
 .el-table--enable-row-hover .el-table__body tr:hover>td{
 background-color: #E5E7EA !important;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue